import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ChatRequest } from '../../../models/ai-insights/chat-request';
import { ChatExchange } from '../../../models/ai-insights/chat-exchange';
import { ChatSuggestions } from '../../../models/ai-insights/chat-suggestions';
import { ChatSessions } from '../../../models/ai-insights/chat-sessions';
import { ChatSession } from '../../../models/ai-insights/chat-session';

export const AiInsightsChatRequestActions = createActionGroup({
  source: 'AI INSIGHTS - CHAT REQUEST',
  events: {
    requestChat: props<{
      chatRequest: ChatRequest,
      chatExchangeId: string,
      timestamp: string
    }>(), // API CALL
    requestChatSuccess: props<{ chatExchange: ChatExchange }>(),
    requestChatError: props<{ chatExchange: ChatExchange }>(),
  },
});

export const AiInsightsChatSessionActions = createActionGroup({
  source: 'AI INSIGHTS - CHAT SESSION',
  events: {
    startNewChatSession: props<{ sessionId: string }>(),
    selectExistingChatSession: props<{ sessionId: string }>(),
    getChatSessions: props<{ page?: number }>(),
    getChatSessionsSuccess: props<{ sessions: ChatSessions }>(),
    getChatSessionsError: emptyProps(),
    getChatSessionDetail: props<{ sessionId: string, page?: number }>(),
    getChatSessionDetailSuccess: props<{
      sessionDetail: ChatExchange[],
      page: number,
      totalPages: number
    }>(),
    getChatSessionDetailError: emptyProps(),
    renameChatSession: props<{ sessionId: string, sessionTitle: string }>(),
    renameChatSessionSuccess: props<{ session: ChatSession }>(),
    renameChatSessionFail: emptyProps(),
    deleteChatSession: props<{ sessionId: string }>(),
    deleteChatSessionSuccess: props<{ sessionId: string }>(),
    deleteChatSessionFail: emptyProps(),
  },
});

export const AiInsightsChatSuggestionsActions = createActionGroup({
  source: 'AI INSIGHTS - CHAT SUGGESTIONS',
  events: {
    getSuggestions: props<{ lang: string }>(),
    getSuggestionsSuccess: props<{ chatSuggestions: ChatSuggestions }>(),
    getSuggestionsError: emptyProps(),
  },
});